import type { FactoryFitsActions, FactoryFitsState, StoreSlice } from '../types'

const initialDealerFitsState: FactoryFitsState = {
  archivedFactoryFits: [],
  factoryFitsChecked: false
} as const

export const createFactoryFitsSlice: StoreSlice<
  FactoryFitsState & FactoryFitsActions
> = set => ({
  // State
  ...initialDealerFitsState,

  // Actions
  setArchivedFactoryFits: val =>
    set({ archivedFactoryFits: val }, false, 'setArchivedFactoryFits'),

  setFactoryFitsChecked: val =>
    set({ factoryFitsChecked: val }, false, 'setFactoryFitsChecked'),

  toggleFactoryFitChecked: () =>
    set(
      state => ({ factoryFitsChecked: !state.factoryFitsChecked }),
      false,
      'toggleFactoryFitChecked'
    ),

  archiveFactoryFit: fit =>
    set(
      state => ({
        archivedFactoryFits: [...state.archivedFactoryFits, fit]
      }),
      false,
      'archiveFactoryFit'
    ),

  onRemoveArchivedFactoryFit: id =>
    set(
      state => ({
        archivedFactoryFits: state.archivedFactoryFits.filter(f => f.id !== id)
      }),
      false,
      'onRemoveArchivedFactoryFit'
    ),
  resetFactoryFits: () => set(initialDealerFitsState, false, 'resetFactoryFits')
})
